export default __webpack_public_path__ + "static/emoji2-7336ee3faa59268eb8ad42dc5b429f53.gif";